// extracted by mini-css-extract-plugin
export default {"fileIcon":"FileIcon_fileIcon__DMVvi","fileIconSubIcon":"FileIcon_fileIconSubIcon__63j9j","subIcon":"FileIcon_subIcon__NRsxy","disabled":"FileIcon_disabled__OyWIq"};